/**
 * Where the kiosk app lives: '' on kiosk.chain29.com (the subdomain IS the kiosk),
 * '/pwa/kiosk' or '/kiosk' with path routing (localhost, *.ondigitalocean.app, chain29.com).
 * Same subdomain rule as App.js getSubdomain().
 */
export function kioskBase() {
  const host = window.location.hostname;
  const local = host.includes('localhost') || host.includes('ondigitalocean.app');
  const parts = host.split('.');
  if (!local && parts.length >= 3 && parts[0].toLowerCase() === 'kiosk') return '';
  return window.location.pathname.startsWith('/pwa/kiosk') ? '/pwa/kiosk' : '/kiosk';
}

/** An absolute kiosk path: kioskPath('payment') -> '/kiosk/payment' or '/payment'. */
export const kioskPath = (route = '') => `${kioskBase()}/${route.replace(/^\//, '')}`;

/** The reader-unavailable words (docs/POS_PAYMENT_STATUS_PANEL.md, Kiosk). */
export const READER_UNAVAILABLE = 'Card reader unavailable — please see staff';

/**
 * Whether the order in progress may be abandoned (cancelled before the kitchen):
 * nothing was charged or might still be (no try, or the last try was declined /
 * cancelled). A timed-out / error try may still be approved late, and a partial
 * payment cannot be abandoned - those stay for the sweep / staff.
 */
export function canAbandon(active) {
  if (!active?.order) return false;
  if (active.approved_cents > 0) return false;
  return !active.payment_id || ['declined', 'cancelled'].includes(active.status);
}
